const applyTalentChoices = (character, boughtTalents, skills, talents) => {
    const result = {
        extraCareerSkills: [],
        dieModifiers: [],
        weaponProperties: {},
        itemHP: {},
        itemMods: {},
    };

    const tc = character?.TalentChoices;
    if (!tc) { return result; }

    const boughtKeys = new Set((boughtTalents || []).map((b) => b.key));

    for (const selKey of Object.keys(tc)) {
        const sel = tc[selKey];
        if (!sel || !sel.talentKey) { continue; }
        if (!boughtKeys.has(sel.talentKey)) { continue; }

        const talent = talents.find((t) => t.Key === sel.talentKey);
        const choice = talent?.Choices?.[sel.choiceIndex];
        if (!choice) { continue; }

        if (choice.Type === "ItemMod") {
            const v = sel.value;
            if (v && v.itemId && v.modKey) { result.itemMods[v.itemId] = v.modKey; }
            continue;
        }

        const values = Array.isArray(sel.value)
            ? sel.value
            : (sel.value !== undefined && sel.value !== null && sel.value !== "" ? [sel.value] : []);

        if (choice.Type === "Skill") {
            values.forEach((k) => {
                const sk = skills.find((s) => s.Key === k);
                if (!sk) { return; }
                if (choice.MakeCareer === "true") { result.extraCareerSkills.push(sk.skill); }
                if (choice.BoostDie === "true") { result.dieModifiers.push({ SkillKey: k, BoostCount: 1 }); }
            });
        } else if (choice.Type === "Weapon" || choice.Type === "Item") {
            values.forEach((id) => {
                if (choice.SetProperty) {
                    if (!result.weaponProperties[id]) { result.weaponProperties[id] = []; }
                    result.weaponProperties[id].push(choice.SetProperty);
                }
                if (choice.HPChange) {
                    result.itemHP[id] = (result.itemHP[id] || 0) + (parseInt(choice.HPChange) || 0);
                }
            });
        }
    }

    return result;
};

export default applyTalentChoices;
